<template>
  <div class="flex fixed right-0 bottom-0 left-0 z-10000 justify-between items-center text-xs font-medium leading-none bg-gray-950 bg-opacity-95 border-t border-gray-800">
    <div>
      <div class="flex divide-x divide-gray-750">
        <div
          v-tooltip="'System status'"
          class="bottom-bar__item"
        >
          <system-status />
        </div>
        <div
          v-tooltip="'Gas Price'"
          class="bottom-bar__item"
        >
          <gas-tracker />
        </div>
        <div
          v-tooltip="'Customize Gas'"
          class="hidden md:block bottom-bar__item"
        >
          <gas-preset>
            <template #button="{show, currentPresetName}">
              <button
                class="flex items-center font-medium text-white"
                @click="show()"
              >
                <i class="mr-2 text-blue-300 fad fa-sliders-v-square" />
                Preset: {{ currentPresetName }}
              </button>
            </template>
          </gas-preset>
        </div>
        <div
          v-tooltip="'Block number'"
          class="hidden md:block bottom-bar__item"
        >
          <live-badge />
        </div>
        <div
          v-tooltip="'ETH Price'"
          class="bottom-bar__item"
        >
          <div class="flex items-center">
            <i class="mr-2 text-gray-200 fab fa-ethereum" />
            <div class="font-medium tabular-nums text-white">
              ${{ formatNumber(ethPrice, 0) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center h-full">
      <a
        v-tooltip="'Follow us on Twitter'"
        href="https://twitter.com/compass_nft/"
        target="_blank"
        class="text-white bg-brand-twitter bg-opacity-90 hover:bg-opacity-100 cursor-pointer bottom-bar__item"
      >
        <i class="fab fa-twitter" />
      </a>
      <a
        v-tooltip="'Join Our Discord'"
        href="https://discord.gg/rt6xh9D6qk"
        target="_blank"
        class="text-white bg-brand-discord bg-opacity-90 hover:bg-opacity-100 cursor-pointer bottom-bar__item"
      >
        <i class="fab fa-discord" />
      </a>
      <help-widget />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import GasPreset from "./GasPreset.vue";
import GasTracker from "./GasTracker.vue";
import HelpWidget from "./HelpWidget.vue";
import LiveBadge from "./LiveBadge.vue";
import SystemStatus from "./SystemStatus.vue";
import { formatNumber } from "@/utils/filters"

export default defineComponent({
  components: { LiveBadge, GasTracker, HelpWidget, GasPreset, SystemStatus },

  setup() {
    return {
      formatNumber,
    }
  },

  computed: {
    ethPrice() {
      return this.$store.getters['gas/ethPrice'];
    }
  }

})
</script>


<style>
  .bottom-bar__item   {
    @apply py-1.5 px-2;
  }
</style>